import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppStateService } from '../../services/app-state.service';
import { LoggerService } from '../../services/logger/logger.service';
import { LoadingSpinnerService } from '../../services/loading-spinner.service';
import { NotificationService } from '../../modules/general/services/notification.service';
import { NotificationType } from '../../modules/general/models/notification-type';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { BookingCapacityService } from '../../modules/booking/services/booking-capacity.service';
import { OrderStateService } from '../../modules/order/services/order-state.service';
import { ScreenSaverService } from '../../modules/vu/services/screen-saver.service';
import { ShopSettingsService } from '../../modules/general/services/shop-settings.service';

@Component({
  selector: 'app-page-main',
  templateUrl: './page-main.component.html',
  styleUrls: ['./page-main.component.css']
})
export class PageMainComponent implements OnInit, OnDestroy {

  onLangChange: Subscription;
  bookingCapacityMessageChange: Subscription;
  appStateServiceReinitializeSubscription: Subscription;

  initialize = false;

  constructor(
    private appStateService: AppStateService,
    private logger: LoggerService,
    private loadingSpinnerService: LoadingSpinnerService,
    private translateService: TranslateService,
    private notificationService: NotificationService,
    private bookingCapacityService: BookingCapacityService,
    private orderStateService: OrderStateService,
    private screenSaverService: ScreenSaverService,
    private shopSettingsService: ShopSettingsService,
  ) { }

  ngOnInit() {
    this.initialize = true;
    this.loadingSpinnerService.show();
    this.orderStateService.orderRemoveFromLocalStore();

    this.bookingCapacityMessageChange = this.bookingCapacityService.messageChange.subscribe(() => {
      this.showAvailableTicketCount();
    });

    this.onLangChange = this.translateService.onLangChange.subscribe(() => {
      this.showAvailableTicketCount();
    });

    this.appStateServiceReinitializeSubscription = this.appStateService.reinitialize().subscribe(
      done => {
        this.loadingSpinnerService.hide();
        this.logger.info('PageMainComponent: appStateService reinitialized.');
        this.bookingCapacityService.start();
        this.showAvailableTicketCount();
        if (this.shopSettingsService.isVUMode) {
          this.screenSaverService.isMainPage = true;
          this.screenSaverService.start();
        }
        this.initialize = false;
      },
      error => {
        this.loadingSpinnerService.hide();
        this.logger.error(`PageMainComponent: appStateService reinitialized error: ${error.message}.`);
        this.initialize = false;
      }
    );
  }

  showAvailableTicketCount() {
    if (!this.bookingCapacityService.isEnabled) {
      return;
    }
    this.notificationService.show(
      PageMainComponent.name,
      this.bookingCapacityService.availableTicketQuantityMessage,
      NotificationType.Success);
  }

  ngOnDestroy(): void {
    if (this.screenSaverService.isMainPage && this.shopSettingsService.isVUMode) {
      this.screenSaverService.isMainPage = false;
    }

    this.bookingCapacityService.stop();

    if (this.bookingCapacityMessageChange) {
      this.bookingCapacityMessageChange.unsubscribe();
      this.bookingCapacityMessageChange = null;
    }

    if (this.shopSettingsService.isVUMode && !this.screenSaverService.isShow) {
      this.screenSaverService.stop();
    }

    if (this.onLangChange) {
      this.onLangChange.unsubscribe();
      this.onLangChange = null;
    }
    if (this.appStateServiceReinitializeSubscription) {
      this.appStateServiceReinitializeSubscription.unsubscribe();
      this.appStateServiceReinitializeSubscription = null;
    }

    this.notificationService.hide(PageMainComponent.name);
  }
}
